import { ImageFilterCenterFocusWeakIcon } from './ImageFilterCenterFocusWeakIcon';

/**
 * author: Google
 * id 50F3F396-4286-4D09-B726-4F626649BC04
 * name image-filter-center-focus-weak
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-filter-center-focus-weak.svg
 * tags
 * - Photography 
 */
export const ImageFilterCentreFocusWeakIcon = ImageFilterCenterFocusWeakIcon;
export default ImageFilterCentreFocusWeakIcon